import { FieldValues, Path, RegisterOptions } from 'react-hook-form';
import { HookFormInputProps } from './types';

export function buildControllerRules<T extends FieldValues>(
  props: HookFormInputProps<T>,
  extraRules?: RegisterOptions<T, Path<T>>
) {
  return {
    required: {
      value: !!props.isRequired,
      message: props.requiredErrorMessage || 'This field is required'
    },
    minLength: props.minLength && {
      value: props.minLength,
      message: `This field must be at least ${props.minLength} characters long`
    },
    maxLength: props.maxLength && {
      value: props.maxLength,
      message: `This field must be at most ${props.maxLength} characters long`
    },
    ...(extraRules as unknown as object),
    ...props.rules
  };
}
